import { render } from "./ModalUplinkRelocator.vue?vue&type=template&id=5cd7f934"
import script from "./ModalUplinkRelocator.vue?vue&type=script&lang=js"
export * from "./ModalUplinkRelocator.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__